import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
const createPaymentIntent = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.createPaymentIntent(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const doCheckOut = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.doCheckout(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => {
        console.log("Error", error);
        throw error;
      });
  };
};

const createWalletPaymentIntent = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.createWalletPaymentIntent(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const userMetaDetails = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.userMetaDetails(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export {
  createPaymentIntent,
  doCheckOut,
  createWalletPaymentIntent,
  userMetaDetails,
};
